(() => {
  document.querySelectorAll('[data-it-cro-stage]').forEach(stage => {
    const productId = stage.dataset.productId;
    const root = document.querySelector(`product-info.it-jewellery-pdp[data-product-id="${productId}"]`) || document.querySelector('product-info.it-jewellery-pdp');
    if (!root || stage.dataset.ready) return;
    stage.dataset.ready = 'true';

    const relatedHeading = [...document.querySelectorAll('.related-products h1, .related-products h2, .related-products .title, section[id*=related] h1, section[id*=related] h2')].find(el => /you may also like/i.test(el.textContent || ''));
    if (relatedHeading) relatedHeading.textContent = 'Complete the look';

    const rating = stage.querySelector('[data-it-cro-rating]');
    const payment = root.querySelector('.it-jewellery-payment-note');
    if (rating && payment) payment.after(rating);

    const stagedDetails = stage.querySelector('[data-it-cro-details]');
    const details = root.querySelector('.it-jewellery-details');
    if (details && stagedDetails) {
      [...stagedDetails.children].forEach(node => details.prepend(node));
      const oldDescription = [...details.querySelectorAll('details')].find(d => /description/i.test(d.querySelector('summary')?.textContent || '') && !d.classList.contains('it-cro-specs'));
      if (oldDescription) {
        const descriptionBody = oldDescription.querySelector('.it-detail-content');
        const descriptionText = descriptionBody?.textContent?.replace(/\s+/g, ' ').trim() || '';
        if (!descriptionText) {
          oldDescription.remove();
        } else {
          oldDescription.setAttribute('open', '');
          oldDescription.dataset.itFullDescription = 'true';
          const label = oldDescription.querySelector('summary span:first-child');
          if (label) label.textContent = 'Full product description';
        }
      }
    }

    const overrideOpen = stage.querySelector('[data-it-cro-override-open]');
    const overrideDialog = stage.querySelector('[data-it-cro-override-dialog]');
    if (overrideOpen) {
      root.querySelector('.it-jewellery-assistance')?.after(overrideOpen);
      overrideOpen.addEventListener('click', () => overrideDialog?.showModal?.());
    }
    if (overrideDialog) {
      document.body.append(overrideDialog);
      overrideDialog.querySelector('[data-it-cro-override-close]')?.addEventListener('click', () => overrideDialog.close());
      overrideDialog.addEventListener('click', e => { if (e.target === overrideDialog) overrideDialog.close(); });
    }

    enhanceOptions(root);
    root.addEventListener('change', () => setTimeout(() => enhanceOptions(root), 50), true);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, e => { if (e?.data?.sectionId === root.dataset.section) setTimeout(() => enhanceOptions(root), 0); });
    }

    installConfidenceShowroom(root);
    stage.remove();
  });

  function enhanceOptions(root) {
    let variants = [];
    try { variants = JSON.parse(root.querySelector('[data-it-variant-data]')?.textContent || '[]'); } catch (_) {}
    const title = (root.querySelector('h1')?.textContent || '').toLowerCase();
    const sku = (root.querySelector('[id^="Sku-"]')?.textContent || '')
      .replace(/^\s*SKU\s*/i, '')
      .trim();

    root.querySelectorAll('[data-it-variant-zone] variant-selects fieldset').forEach((fieldset, index) => {
      const legend = fieldset.querySelector('legend'); if (!legend) return;
      const raw = (legend.textContent.split(':')[0] || '').trim();
      const radios = [...fieldset.querySelectorAll('input[type=radio]')];
      const values = radios.map(i => i.value.trim()).filter(Boolean);
      const n = raw.toLowerCase().trim();

      if (n === 'default' && values.length === 1 && values[0].toLowerCase() === 'default') {
        fieldset.hidden = true;
        fieldset.classList.add('it-synthetic-default-option');
        fieldset.setAttribute('aria-hidden', 'true');
        return;
      }

      if (n === 'weight' && values.length === 1 && sku && values[0].toLowerCase() === sku.toLowerCase()) {
        fieldset.hidden = true;
        fieldset.setAttribute('aria-hidden', 'true');
        return;
      }

      let display = customerName(raw, values, title);
      if (n === 'weight' && values.length === 1 && /^[A-Z0-9][A-Z0-9._/-]{2,}$/i.test(values[0]) && !looksLikeWeight(values[0])) {
        display = 'Reference';
      }

      if (legend.childNodes[0]) legend.childNodes[0].textContent = `${display}: `;
      if (/size/i.test(display)) fieldset.classList.add('it-size-options');

      if (/metal|material/i.test(n)) {
        fieldset.classList.add('it-metal-options');
        legend.textContent = /color|colour/i.test(display) ? 'Metal colour' : 'Metal';
        radios.forEach(input => {
          const label = fieldset.querySelector(`label[for="${cssEscape(input.id)}"]`);
          if (!label || label.querySelector('.it-metal-tone')) return;
          const tone = document.createElement('span');
          tone.className = 'it-metal-tone';
          tone.setAttribute('aria-hidden', 'true');
          tone.style.setProperty('--it-metal-tone', toneFor(input.value));
          label.prepend(tone);
        });
        return;
      }

      if (!/colour|color|stone|gem|material/i.test(display) || !radios.length || radios.length > 12) return;
      const hasImages = radios.some(i => variants.some(v => v.options?.[index] === i.value && v.image));
      if (hasImages) {
        fieldset.classList.add('it-image-options');
        radios.forEach(input => {
          const label = fieldset.querySelector(`label[for="${cssEscape(input.id)}"]`);
          const variant = variants.find(v => v.options?.[index] === input.value && v.image);
          if (!label || !variant || label.querySelector('.it-option-thumb')) return;
          label.querySelectorAll('.label-unavailable,.visually-hidden').forEach(n => n.remove());
          label.textContent = '';
          const image = document.createElement('img'); image.className = 'it-option-thumb'; image.src = variant.image; image.alt = ''; image.loading = 'lazy';
          const copy = document.createElement('span'); copy.className = 'it-option-copy'; copy.textContent = input.value;
          label.append(image, copy);
        });
      } else if (/colour|color/i.test(display)) {
        fieldset.classList.add('it-tone-options');
        radios.forEach(input => {
          const label = fieldset.querySelector(`label[for="${cssEscape(input.id)}"]`); if (!label || label.querySelector('.it-option-tone')) return;
          const tone = document.createElement('span'); tone.className = 'it-option-tone'; tone.style.setProperty('--it-tone', toneFor(input.value)); label.prepend(tone);
        });
      }
    });
  }

  function installConfidenceShowroom(root) {
    if (document.querySelector('[data-it-jewellery-confidence-suite]')) return;
    root.querySelector('.it-kensington-editorial')?.remove();

    const productTitle = (root.querySelector('h1')?.textContent || 'this jewellery piece').trim();
    const whatsappText = `Hello Imperial Time, I would like help reviewing this jewellery piece: ${productTitle} — ${location.href}`;
    const whatsappUrl = `https://wa.me/447538174795?text=${encodeURIComponent(whatsappText)}`;
    const mapsSearchUrl = 'https://www.google.com/maps/search/?api=1&query=79%20Kensington%20Church%20Street%2C%20London%20W8%204BG';
    const mapsDirectionsUrl = 'https://www.google.com/maps/dir/?api=1&destination=79%20Kensington%20Church%20Street%2C%20London%20W8%204BG';

    const suite = document.createElement('section');
    suite.className = 'it-jewellery-confidence-suite';
    suite.dataset.itJewelleryConfidenceSuite = 'true';
    suite.setAttribute('aria-label', 'Imperial Time jewellery purchase confidence and Kensington showroom support');
    suite.innerHTML = `
      <div class="it-jewellery-confidence-block">
        <div class="page-width it-jewellery-confidence-grid">
          <div class="it-jewellery-confidence-intro">
            <p class="it-jewellery-suite-kicker">Confidence before purchase</p>
            <h2>Inspected by<br>Imperial Time</h2>
          </div>
          <div class="it-jewellery-confidence-story">
            <p>Every jewellery piece offered by Imperial Time is professionally inspected before sale. We review materials, setting security, condition and presentation, and check the product details shown on the listing before dispatch.</p>
            <div class="it-jewellery-confidence-points" role="list">
              <span role="listitem">Professional inspection</span>
              <span role="listitem">Materials &amp; setting reviewed</span>
              <span role="listitem">Secure handling</span>
              <span role="listitem">Kensington showroom support</span>
            </div>
          </div>
        </div>
      </div>
      <div class="it-jewellery-service-block">
        <div class="page-width it-jewellery-service-grid">
          <div class="it-jewellery-service-heading">
            <p class="it-jewellery-suite-kicker">After the decision</p>
            <h2>Delivery, returns<br>&amp; support</h2>
          </div>
          <div class="it-jewellery-service-card"><h3>Secure delivery</h3><p>Orders are sent using secure, tracked and appropriately insured delivery. Delivery options, estimates and any charges are shown at checkout.</p><a href="/policies/shipping-policy">Shipping policy</a></div>
          <div class="it-jewellery-service-card"><h3>14-day returns</h3><p>Eligible purchases can be returned within 14 days subject to the current returns policy and its condition requirements.</p><a href="/policies/refund-policy">Returns policy</a></div>
          <div class="it-jewellery-service-card"><h3>Specialist support</h3><p>Our Kensington team can help with sizing, materials, additional photographs or video, and showroom appointments before or after purchase.</p></div>
        </div>
      </div>
      <div class="page-width it-jewellery-consultation-wrap">
        <div class="it-jewellery-consultation">
          <div class="it-jewellery-consultation-header">
            <div class="it-jewellery-consultation-copy"><p class="it-jewellery-suite-kicker">Kensington jewellery consultation</p><h2>Would you like a specialist to review this piece?</h2><p>Before you order, our Kensington team can help you review the materials, dimensions, condition, sizing and purchase options shown on this listing.</p></div>
            <div class="it-jewellery-consultation-actions"><a class="it-jewellery-suite-btn it-jewellery-suite-btn--wa" href="${whatsappUrl}" target="_blank" rel="noopener noreferrer" data-jewellery-action="whatsapp">WhatsApp a Jewellery Specialist</a><a class="it-jewellery-suite-btn" href="https://book.imperialtime.co.uk/185231000000030056/#/185231000000030056" target="_blank" rel="noopener noreferrer" data-jewellery-action="appointment">Book a Kensington Appointment</a></div>
          </div>
          <div class="it-jewellery-showroom-grid">
            <div class="it-jewellery-showroom-info"><p class="it-jewellery-suite-kicker">Visit Imperial Time</p><h3>Our Kensington Showroom</h3><address>79 Kensington Church Street<br>London W8 4BG</address><p>Monday–Friday: 10:00–18:00<br>Saturday: Appointment only<br>Sunday: Closed</p><div class="it-jewellery-showroom-links"><a href="${mapsDirectionsUrl}" target="_blank" rel="noopener noreferrer">Get directions in Google Maps ↗</a><a href="${mapsSearchUrl}" target="_blank" rel="noopener noreferrer">Open location ↗</a></div></div>
            <a class="it-jewellery-showroom-image" href="${mapsSearchUrl}" target="_blank" rel="noopener noreferrer" aria-label="View Imperial Time Kensington showroom in Google Maps"><img src="https://cdn.shopify.com/s/files/1/0952/5562/6071/files/Kensington-Showroom.jpg?v=1776083319" alt="Interior of Imperial Time Kensington showroom at 79 Kensington Church Street, London" loading="lazy" width="1248" height="832"><span>Kensington · View on Google Maps ↗</span></a>
            <div class="it-jewellery-map-card"><iframe title="Google map showing Imperial Time at 79 Kensington Church Street, London W8 4BG" src="https://maps.google.com/maps?q=79%20Kensington%20Church%20Street%2C%20London%20W8%204BG&z=15&output=embed" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe><a href="${mapsSearchUrl}" target="_blank" rel="noopener noreferrer">Open in Google Maps ↗</a></div>
          </div>
        </div>
        <div class="it-jewellery-benefit-strip" role="list" aria-label="Imperial Time purchase benefits">
          <div class="it-jewellery-benefit" role="listitem"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9h16v11H4zM3 6h18v3H3zM12 6v14M12 6c-2.8 0-5-1.2-5-3 0-1.1.9-2 2-2 1.8 0 3 2.1 3 5Zm0 0c2.8 0 5-1.2 5-3 0-1.1-.9-2-2-2-1.8 0-3 2.1-3 5Z"/></svg><h3>Established London Luxury Retailer</h3><p>Kensington showroom · specialist support since 2015.</p></div>
          <div class="it-jewellery-benefit" role="listitem"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2M8 2h8"/></svg><h3>Kensington Showroom &amp; Support</h3><p>Mon–Fri 10:00–18:00 · Saturday by appointment · Sunday closed.</p></div>
          <div class="it-jewellery-benefit" role="listitem"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3 5 6v5c0 4.6 2.7 8.2 7 10 4.3-1.8 7-5.4 7-10V6Z"/><path d="m9 12 2 2 4-4"/></svg><h3>Secure High-Value Transactions</h3><p>3D Secure online checkout and in-store card payment available.</p></div>
          <div class="it-jewellery-benefit" role="listitem"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 7h11v11H7zM4 10V4h6M4 4l5 5M20 14v6h-6M20 20l-5-5"/></svg><h3>14-Day Returns</h3><p>Eligible online purchases can be returned within 14 days; exclusions apply.</p></div>
        </div>
      </div>
    `;

    const related = document.querySelector('.related-products')?.closest('.shopify-section') || document.querySelector('section[id*="related"]')?.closest('.shopify-section') || document.querySelector('.related-products');
    const reviews = document.querySelector('.it-client-reviews');
    if (related?.parentNode) related.parentNode.insertBefore(suite, related);
    else if (reviews?.parentNode) reviews.after(suite);
    else root.after(suite);
  }

  function customerName(raw, values, title) {
    const n = raw.toLowerCase().trim();
    if (n === 'color') return 'Colour';
    if (/ring\s*size/.test(n) || (n === 'size' && /ring/.test(title))) return 'Ring size';
    if (n === 'weight') {
      const joined = values.join(' ').toLowerCase();
      const weight = values.length && values.every(looksLikeWeight);
      const jewellery = /onyx|malachite|agate|pearl|diamond|ruby|sapphire|emerald|topaz|amethyst|opal|turquoise|garnet|quartz|zircon|moissanite|silver|gold|rose|white|yellow|black|blue|green|red|pink|mother of pearl|stone|colour|color/.test(joined);
      if (!weight && jewellery) return 'Stone / colour';
    }
    if (/stone|gem/.test(n) && /colour|color|type/.test(n)) return 'Stone / colour';
    return raw;
  }

  function looksLikeWeight(value) {
    return /^\s*\d+(?:\.\d+)?\s*(?:g|gram|grams|kg|ct|carat|carats|oz)\s*$/i.test(String(value || ''));
  }

  function toneFor(value) { const v=value.toLowerCase(); if(/rose/.test(v))return'#c99b8c';if(/yellow|gold/.test(v))return'#d5b55f';if(/white|silver|platinum/.test(v))return'#d8d9d6';if(/black|onyx/.test(v))return'#222';if(/blue|sapphire/.test(v))return'#244e8d';if(/green|malachite|emerald/.test(v))return'#2e6a4b';if(/red|ruby/.test(v))return'#9a2f39';if(/pink/.test(v))return'#d7a4ad';return'#d8d5cf'; }
  function cssEscape(v) { return window.CSS?.escape ? CSS.escape(String(v)) : String(v).replace(/[^a-zA-Z0-9_-]/g,'\\$&'); }
})();
